import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import { datadogRum } from '@datadog/browser-rum';
import { environment } from 'src/environments/environment';

const ID_PATH_SEGMENT = /^(\d+|[0-9a-f]{16,}|[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i;

@Injectable()
export class DatadogErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    console.error('Global Error:', error);

    datadogRum.addError(this.toError(error), {
      source: 'frontend',
      context: {
        env: environment.DATADOG_ENV,
      },
    });
  }

  private toError(error: unknown): Error {
    if (error instanceof Error) {
      return error;
    }
    if (error instanceof HttpErrorResponse) {
      return this.toHttpError(error);
    }
    return new Error(String(error ?? 'Unknown error'));
  }

  private toHttpError(response: HttpErrorResponse): Error {
    const error = new Error(`${response.status} ${response.statusText}: ${this.toEndpoint(response.url)}`);
    error.name = 'HttpErrorResponse';
    return error;
  }

  private toEndpoint(url: string | null): string {
    if (!url) {
      return 'unknown URL';
    }
    const path = new URL(url, window.location.origin).pathname;
    return path
      .split('/')
      .map((segment) => (ID_PATH_SEGMENT.test(segment) ? ':id' : segment))
      .join('/');
  }
}
